require('flatpickr');
require('flatpickr/dist/l10n/nl.js');

(function () {
    "use strict";

    /* scroll to anchor tag */
    $('.btn.rdn_btn').each(function() {
        let $button = $(this);

        let $href = $button.attr('href');

        if (typeof $href != 'undefined' && $href.startsWith('#')) {

            let $element = $($href);

            if ($element.length) {

                $button.on('click', function (event) {
                        event.preventDefault();

                        $('html, body').animate({
                            scrollTop: $element.offset().top - 100
                        }, 300);
                    })
            }

        }
    });

    /* script scrollcue  */
    scrollCue.init({
        percentage: 0.95
    });

    /* Cloned Navigation element */
    const navwhite = document.querySelector(".nav_white");
    if (navwhite) {
        const navElement = navwhite.cloneNode(true);
        document.querySelector(".cloned_nav").appendChild(navElement);
    }

    /* navigation script */
    if (document.querySelector(".header")) {
        const nav_menu = document.querySelector(".header").querySelectorAll(".has_child");

        for (var i = 0; i < nav_menu.length; i++) {
            nav_menu[i].addEventListener('mouseenter', function () {
                this.classList.add('active');
            });
            nav_menu[i].addEventListener('mouseleave', function () {
                this.classList.remove('active');
            });
        }
    }

    /* mobile menu script */
    if (document.querySelector(".mobile_menu")) {
        //adding icon for dropdown button in mobile menu
        const linkwithchild = document.querySelector(".mobile_menu").querySelectorAll(".mdropdown");

        for (let index = 0; index < linkwithchild.length; index++) {
            const newContent = '<i class="mbtn_drop fa fa-angle-down"></i>';
            linkwithchild[index].insertAdjacentHTML('beforeend', newContent);
        }

        //add class for clicked icon
        const mb_menu = document.querySelector(".mobile_menu").querySelectorAll(".mdropdown > i");

        for (var imb = 0; imb < mb_menu.length; imb++) {
            mb_menu[imb].addEventListener('click', function (e) {
                //toogle class active for the icon button
                this.parentNode.classList.toggle('active');
                //dropdown slide effect with 200ms transition
                slideToggle(this.parentNode.querySelector('.mdropdown_child'), 200);
                e.preventDefault()
            });
        }
    }

    /* Cloned menu appear */
    // When the user scrolls down 400px from the top of the document, show the cloned menu
    const clonedMenu = document.querySelector(".cloned");

    function scrollCloned() {

        if (document.body.scrollTop > 400 || document.documentElement.scrollTop > 400) {
            clonedMenu.classList.add('fixed_menu');
        } else {
            clonedMenu.classList.remove('fixed_menu')
        }
    }

    //scrolling effect
    window.onscroll = function () {
        //clone the menu
        if (clonedMenu) {
            scrollCloned();
        }
    };


    /* gallery  popup script */
    const lightbox = GLightbox({
        touchNavigation: true,
        loop: true,
        autoplayVideos: true,
        selector: '*[data-gallery]',
        zoomable: false,
        height: 'auto'
    });

    /* video  popup script */
    const popupVideo = GLightbox({
        touchNavigation: true,
        loop: true,
        autoplayVideos: true,
        selector: '.popup_video',
        zoomable: false,
        height: 'auto',
        draggable: false,
        skin: 'body_popupvideo'
    });

    /* timeline  popup script */
    const popupTimeline = GLightbox({
        touchNavigation: false,
        selector: '.popup_timeline',
        zoomable: false,
        height: 'auto',
        draggable: false,
        skin: 'body_popupvideo'
    });

    /* tilting effect script  */
    VanillaTilt.init(document.querySelector(".rdn_tilt"), {
        max: 15,
        speed: 600,
        easing: "cubic-bezier(.03,.98,.52,.99)", // Easing on enter/exit.
        glare: false,
    });

    $(function () {
        $('[data-bs-toggle="popover"]').popover()
    })

})();
